import { Vue, Component, Prop } from 'vue-property-decorator'
import { ScreenText } from '@/lang/ScreenText'
import WidgetForm from './WidgetForm/WidgetForm.vue'
import GenerateForm from './GenerateForm/GenerateForm.vue'
import { organizationalElements } from './formData/organizationalElements'
import { scholarInformation } from './formData/scholarDetails'
import { guardianInformation } from './formData/guardianDetails'
import { guardianEmergencyInformation } from './formData/emergencyContact'
import { CustomQuestion } from './formData/customFieldDetails'
import formsStore from '@/store/modules/forms/formsStore'
@Component({
  name: 'fm-making-form',
  components: {
    GenerateForm,
    WidgetForm
  }
})
export default class Container extends Vue {
  private objScreenText: ScreenText = new ScreenText()
  public resetJson: boolean = false
  public widgetFormSelect: any = null
  public preview: boolean = false
  public previewVisible: boolean = false
  public scholarInformation = scholarInformation
  public organizationalElements = organizationalElements
  public guardianInformation = guardianInformation
  public guardianEmergencyInformation = guardianEmergencyInformation
  public CustomQuestion = CustomQuestion
  public addNewElement: any = ''
  public widgetModels: Object = {}
  public currentPartIndex: number = 0
  public formsDetails: any = { list: [], config: {} }

  get formData() {
    return this.applicationParts[this.formIndex]
      ? this.applicationParts[this.formIndex].source
      : { list: [], config: {} }
  }

  get applicationParts() {
    return formsStore.applicationsPartsData.forms
  }

  @Prop()
  formIndex!: number

  @Prop()
  selectedType!: string

  addFormDetails() {
    this.formsDetails = this.applicationParts[this.formIndex]
      ? this.applicationParts[this.formIndex].source
      : { list: [], config: {} }
  }

  mounted() {
    this.addFormDetails()
  }
}
